import {IQuickScanAnswerData, ITisAnswerValue} from './project-data';
import {IQuestionData} from '..';

/**
 * Common contract of the legacy `QuickscanAnswers` and the PRM 2.0
 * `ProjectAnalysisAnswers` stores, so the shared quickscan components can
 * render either scheme.
 */
export interface IQuickscanAnswerEntry {
    readonly questionId?: number;
    readonly answerId?: number;
    readonly remarks?: string;
    setAnswerId(id: number | undefined): void;
    setRemarks(remarks: string): void;
}

export interface IQuickscanAnswerStore {
    getQuickscanAnswerForQuestion(question: IQuestionData): IQuickscanAnswerEntry;
    updateQuickscanAnswer(question: IQuestionData, selectedAnswerId: number | undefined): void;
    getQuickscanAnswers(): IQuickScanAnswerData[];
    // Optional typed-answer support: only the project analysis scheme can
    // store non-multiplechoice answers (text, date, integer, bool, ...).
    getValueForQuestion?(question: IQuestionData): ITisAnswerValue;
    updateAnswer?(question: IQuestionData, value: ITisAnswerValue): void;
    getAnswerIdsForQuestion?(question: IQuestionData): number[];
    updateMultiAnswer?(question: IQuestionData, selectedAnswerIds: number[]): void;
}

export class QuickscanAnswers implements IQuickscanAnswerStore {
    private quickscanAnswers: QuickscanAnswer[];

    constructor(data: IQuickScanAnswerData[]) {
        this.quickscanAnswers = data.map(answer => new QuickscanAnswer(answer));
    }

    public getQuickscanAnswerForQuestion(question: IQuestionData): QuickscanAnswer {
        let quickscanAnswer = this.quickscanAnswers.find((answer) => answer.questionId === question.id);
        if (quickscanAnswer === undefined) {
            quickscanAnswer = new QuickscanAnswer({questionId: question.id});
            this.quickscanAnswers.push(quickscanAnswer);
        }

        return quickscanAnswer;
    }

    public updateQuickscanAnswer(question: IQuestionData, selectedAnswerId: number | undefined) {
        const quickscanAnswer = this.getQuickscanAnswerForQuestion(question);
        quickscanAnswer.setAnswerId(selectedAnswerId);
    }

    getQuickscanAnswers() {
        return this.quickscanAnswers;
    }
}

export class QuickscanAnswer {
    questionId?: number;
    answerId?: number;
    remarks?: string;

    constructor(data: IQuickScanAnswerData) {
        this.questionId = data.questionId;
        this.answerId = data.answerId;
        this.remarks = data.remarks;
    }

    public setRemarks(remarks: string) {
        this.remarks = remarks;
    }

    public setAnswerId(id: number | undefined) {
        this.answerId = id;
    }
}
